import { Collapse } from 'bootstrap';

export default class PowerSlider extends HTMLElement {
    private range: HTMLInputElement;
    private valueLabel: HTMLElement;
    private descCollapse: Collapse;

    constructor() {
        super();
        const template = document.getElementById('power-slider') as HTMLTemplateElement;
        const templateContent = template.content;

        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.appendChild(templateContent.cloneNode(true));

        this.range = shadowRoot.getElementById("slider") as HTMLInputElement;
        this.range.style.setProperty('--color', this.getAttribute("data-color"));
        this.range.addEventListener('input', () => this.onRangeInput());
        this.range.addEventListener('change', () => this.onRangeChange());

        this.descCollapse = new Collapse(shadowRoot.getElementById("description") ?? "", { toggle: false });

        this.valueLabel = shadowRoot.getElementById("valueLabel") as HTMLInputElement;
    }

    private onRangeInput(): any {
        this.valueLabel.textContent = (this.range.valueAsNumber * 100).toFixed(0);
        this.dispatchEvent(new Event("input"));
    }

    private onRangeChange(): any {
        this.valueLabel.textContent = (this.range.valueAsNumber * 100).toFixed(0);
        this.dispatchEvent(new Event("change"));
    }

    public get step(): number {
        return parseFloat(this.range.step);
    }
    public set step(val: number) {
        this.range.step = val.toString();
    }

    public get value(): number {
        return this.range.valueAsNumber;
    }
    public set value(val: number) {
        this.range.valueAsNumber = val;
        this.onRangeChange();
    }

    public toggleDescription() {
        this.descCollapse.toggle();
    }
}